<template>
  <button
    v-if="!$auth.isAuthenticated"
    class="btn btn-primary btn-block"
    @click="login"
  >
    Log In
  </button>
</template>

<script>
  export default {
    name: 'LoginButton',
    methods: {
      login () {
        this.$auth.loginWithRedirect({
          audience: 'https://services.conductor.systems',
          scope: 'read:sales',
        })
      },
    },
  }
</script>
